export * from '@primeuix/themes/material/tooltip';
export { default } from '@primeuix/themes/material/tooltip';
